import graphql__e86f8dfa55569dddfaf7 from "./__generated__/MailingListList_query.graphql.ts";import * as React from "react"
import {graphql} from "react-relay";
import {useFragment} from "react-relay/hooks";
import Table from "./presentational/table/Table";
import TableHeader from "./presentational/table/TableHeader";
import TableData, {TextAlignment} from "./presentational/table/TableData";
import {resolvePath, useNavigate} from "react-router";
import StatusBadge from "./presentational/StatusBadge";
import {useIntl} from "react-intl";

type Props = {
    queryRef: any
    searchTerm?: string
    onLoadingChange?: (isLoading: boolean) => void
}

const MailingListList: React.FC<Props> = (props) => {
    const intl = useIntl();
    const data = useFragment(
        graphql__e86f8dfa55569dddfaf7,
        props.queryRef
    );
    const navigate = useNavigate();

    // Filter mailing lists by search term on client side
    const filteredMailingLists = data.mailingLists?.filter(mailingList => {
        if (!props.searchTerm) return true;
        const searchLower = props.searchTerm.toLowerCase();
        return mailingList.name.toLowerCase().includes(searchLower) ||
               mailingList.description?.toLowerCase().includes(searchLower);
    }) || [];

    if (filteredMailingLists.length === 0) {
        return (
            <div className="px-6 pb-6 text-gray-500 text-center">
                {intl.formatMessage({id: 'view.mailingLists.noMailingLists'})}
            </div>
        );
    }

    const formatDate = (dateString: string | null) => {
        if (!dateString) return '-';
        return new Date(dateString).toLocaleDateString();
    };

    return (
        <div className="flex-1 min-h-0 relative overflow-y-auto" aria-label={intl.formatMessage({id: 'navigation.mailingLists'})}>
            <Table>
                <thead>
                    <tr>
                        <TableHeader>{intl.formatMessage({id: 'list.mailingList.header.name'})}</TableHeader>
                        <TableHeader>{intl.formatMessage({id: 'list.mailingList.header.description'})}</TableHeader>
                        <TableHeader className="text-right">{intl.formatMessage({id: 'list.mailingList.header.subscribed'})}</TableHeader>
                        <TableHeader className="text-right">{intl.formatMessage({id: 'list.mailingList.header.unsubscribed'})}</TableHeader>
                        <TableHeader>{intl.formatMessage({id: 'list.mailingList.header.createdAt'})}</TableHeader>
                    </tr>
                </thead>
                <tbody>
                    {filteredMailingLists.map(
                        (mailingList, index) => {
                            const handleRowClick = (event: React.MouseEvent) => {
                                const to = "/marketing/lists/" + mailingList.id;
                                if (event.shiftKey || event.metaKey) {
                                    event.preventDefault();
                                    window.open(resolvePath(to).pathname);
                                } else {
                                    navigate(to);
                                }
                            };
                            return (
                                <tr
                                    key={mailingList.id}
                                    className={(index % 2 === 0 ? 'bg-white' : 'bg-gray-50') + ' hover:bg-gray-100 cursor-pointer' + (mailingList.archivedAt ? ' opacity-50' : '')}
                                    onClick={handleRowClick}
                                >
                                    <TableData>
                                        <span className="font-medium">{mailingList.name}</span>
                                        {mailingList.archivedAt && (
                                            <StatusBadge value="Archived" states={{}} className="ml-2"/>
                                        )}
                                    </TableData>
                                    <TableData>
                                        <span className="text-gray-500 truncate max-w-xs">{mailingList.description || '-'}</span>
                                    </TableData>
                                    <TableData textAlignment={TextAlignment.Right}>
                                        <span className="text-green-600 font-medium">{mailingList.subscribedCount}</span>
                                    </TableData>
                                    <TableData textAlignment={TextAlignment.Right}>
                                        <span className="text-gray-500">{mailingList.unsubscribedCount}</span>
                                    </TableData>
                                    <TableData>
                                        {formatDate(mailingList.createdAt)}
                                    </TableData>
                                </tr>
                            )
                        }
                    )}
                </tbody>
            </Table>
        </div>
    )
}

export default MailingListList;
